import { FormatPhonePipe } from '../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, FormatPhonePipe],
  selector: 'app-affinity-notice',
  templateUrl: './affinity-notice.component.html',
  styleUrls: ['./affinity-notice.component.scss']
})
export class AffinityNoticeComponent implements OnInit {
  @Input() policy: any;
  hideAffinityAlert: boolean;
  agentPhoneNumber: string;
  agentName: string;
  isAcmic: boolean; 

  constructor(private acmicService: AcmicService) {
    this.hideAffinityAlert = false;
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnInit(): void {
    this.agentPhoneNumber = this.policy?.agent?.agentISCPhone && this.policy?.agent?.agentISCPhone?.number
                              ? this.policy?.agent?.agentISCPhone?.number
                              : this.policy?.agent?.agentPhone?.number
    this.agentPhoneNumber = this.agentPhoneNumber?.toString().replace(/\D+/g, '');
    this.agentName = this.policy?.agent?.agentName;
  }

  onClose() {
    this.hideAffinityAlert = true;
  }
}
